import {
    Button,
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
    Popover,
    PopoverContent,
    PopoverTrigger,
    Skeleton,
} from '@repo/shadcn';
import { ChevronsUpDown } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useController } from 'react-hook-form';

import {
    API_LIMIT,
    API_PAGE,
    API_SORT_BY,
    API_SORT_ORDER,
} from '../../../../../constants/api-query-params.constant';
import { useGetGenericsQuery } from '../../../../../features/slice/products/generic/generic-api-slice';

export function GenericsAutoComplete({ control, name }: any) {
    const [open, setOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const { data: searchData, isLoading } = useGetGenericsQuery({
        limit: API_LIMIT.DEFAULT_LIMIT,
        page: API_PAGE.DEFAULT_PAGE,
        search: debouncedSearchTerm || undefined,
        sort_order: API_SORT_ORDER.ASCENDING,
        sort_by: API_SORT_BY.NAME,
    });

    const handleSearchInput = (value: string) => {
        setSearchTerm(value);
    };

    const { field } = useController({ name, control });

    const selectedGenerics = searchData?.data.find(
        (brand: any) => brand.id === field.value,
    );

    if (isLoading) {
        return <Skeleton className="mt-2 h-[40px] w-full" />;
    }

    return (
        <div id="portal-root">
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button
                        variant="outline"
                        role="combobox"
                        aria-expanded={open}
                        className="w-full justify-between   truncate"
                    >
                        <p className="w-[90%] truncate duration-300">
                            {selectedGenerics
                                ? selectedGenerics.name
                                : 'Select generic...'}
                        </p>
                        <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                    </Button>
                </PopoverTrigger>
                <PopoverContent>
                    <Command className="relative w-[280px]">
                        <CommandInput
                            value={searchTerm}
                            onValueChange={handleSearchInput}
                            placeholder="Search generic..."
                            className="truncate"
                        />
                        <CommandList>
                            <CommandEmpty>No generic found.</CommandEmpty>
                            <CommandGroup>
                                {searchData?.data?.map((generic: any) => (
                                    <CommandItem
                                        key={generic.id}
                                        value={generic.name}
                                        onSelect={() => {
                                            field.onChange(generic.id);
                                            setOpen(false);
                                        }}
                                        className="border-b-[1px]"
                                    >
                                        {generic.name}
                                    </CommandItem>
                                ))}
                            </CommandGroup>
                        </CommandList>
                    </Command>
                </PopoverContent>
            </Popover>
        </div>
    );
}
